var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.03 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M14.31 0a.77.77 0 00-.54.22L.2 13.48a.72.72 0 000 1l13.57 13.3a.77.77 0 001.07 0 .74.74 0 000-1L1.8 14l13-12.74a.74.74 0 000-1 .74.74 0 00-.49-.26z",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNS4wMyIgaGVpZ2h0PSIyOCIgdmlld0JveD0iMCAwIDE1LjAzIDI4Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIHN0cm9rZT0iY3VycmVudENvbG9yIiBkPSJNMTQuMzEsMGEuNzcuNzcsMCwwLDAtLjU0LjIyTC4yLDEzLjQ4YS43Mi43MiwwLDAsMCwwLDFsMTMuNTcsMTMuM2EuNzcuNzcsMCwwLDAsMS4wNywwLC43NC43NCwwLDAsMCwwLTFMMS44LDE0bDEzLTEyLjc0YS43NC43NCwwLDAsMCwwLTFBLjc0Ljc0LDAsMCwwLDE0LjMxLDBaIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4K";
export { SvgChevronLeft as ReactComponent };